import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import ModalConfirmOperation from 'src/components/ModalConfirmOperation'
import { useAuth } from 'src/hooks/auth'
import type { DevicesProps } from 'src/pages/authorizedDevices/AutorizedListDevices'
import { api } from 'src/services/api'
import { ExtractItem } from 'src/utils/extractDescription'
import { BeneficiaryDataStep } from './BeneficiaryDataStep'
import { PasswordStep } from './PasswordStep'
import { PixKeyStep } from './PixKeyStep'
import { SuccessOnTransactionStep } from './SuccessOnTrasactionStep'
import { PixFavoretes } from './pixFavorite'

export type NewPixFormProps = {
  nextStep: () => void
}

export type BeneficiaryDataProps = {
  name?: string
  payer_question?: string
  agency?: string
  account?: string
  bank?: string
  key?: string
  amount?: number
  id?: string
  emv?: string
  keyType?: string
  endToEndId?: string
  beneficiaryDocument?: string
}

export function NewPixForm() {
  const [formStep, setFormStep] = useState(1)
  const token = localStorage.getItem('@stricv2:token')
  const [data, setData] = useState<DevicesProps[]>([])
  const [beneficiaryData, setBeneficiaryData] = useState<BeneficiaryDataProps>(
    {} as BeneficiaryDataProps
  )
  const [amount, setAmount] = useState(0)
  const navigate = useNavigate()

  const [transaction, setTransaction] = useState<ExtractItem>()

  const { user } = useAuth()

  const [modalIsOpen, setIsOpen] = useState(false)

  function closeModal() {
    setIsOpen(false)
  }

  const handleFavorite = async () => {
    const result = await api.post(
      '/pix/favorites',
      {
        contactName: beneficiaryData.name,
        keyPix: beneficiaryData.key,
        keyType: beneficiaryData.keyType,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
  }

  return (
    <>
      <ModalConfirmOperation
        user={user}
        afterOpenModal={() => {}}
        closeModal={closeModal}
        modalIsOpen={modalIsOpen && !!transaction}
        data={transaction}
      />

      <div className="z-10">
        {formStep === 1 ? (
          <PixKeyStep
            setBeneficiaryData={setBeneficiaryData}
            nextStep={() => setFormStep(formStep + 1)}
            setStep={setFormStep}
          />
        ) : formStep === 2 ? (
          <BeneficiaryDataStep
            beneficiaryData={beneficiaryData}
            setAmount={setAmount}
            nextStep={() => setFormStep(formStep + 1)}
          />
        ) : formStep === 3 ? (
          <PasswordStep
            beneficiaryData={beneficiaryData}
            amount={amount}
            nextStep={() => setFormStep(formStep + 1)}
            setTransaction={setTransaction}
          />
        ) : formStep === 4 ? (
          <SuccessOnTransactionStep
            handleFavorite={handleFavorite}
            nextStep={() => {
              navigate(`/extract?transactionId=${transaction?.id}`)
            }}
          />
        ) : formStep === 5 ? (
          <PixFavoretes beneficiaryData={beneficiaryData} />
        ) : formStep === 6 ? (
          <>
            {data.length === 3 ? (
              <div className="flex flex-col gap-4 items-center p-4">
                <h1 className="text-[1.875rem] font-bold">
                  Já existem 3 dispositivos cadastrados
                </h1>
                <div className="w-full flex gap-3 justify-center">
                  <button
                    type="button"
                    onClick={() => setFormStep(1)}
                    className="bg-[#004A8A] text-white py-2 px-4 rounded-md"
                  >
                    Voltar
                  </button>
                </div>
              </div>
            ) : (
              <div className="flex flex-col gap-4 items-center p-4">
                <h1 className="text-[1.875rem] font-bold">
                  Dispositivo não cadastrado
                </h1>
                <div className="w-full flex gap-3 justify-center">
                  <button
                    type="button"
                    onClick={() => navigate('/wallet/security-devices/enable')}
                    className="bg-[#004A8A] text-white py-2 px-4 rounded-md"
                  >
                    Cadastrar
                  </button>
                </div>
              </div>
            )}
          </>
        ) : null}
      </div>
    </>
  )
}
